import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // Boot scene handles minimal initial loading
    // Any critical assets needed before preload screen would go here
  }

  create(): void {
    // Set up any global game settings
    this.scale.on('resize', this.handleResize, this);

    // Transition to preload scene
    this.scene.start('PreloadScene');
  }

  private handleResize(gameSize: Phaser.Structs.Size): void {
    // Handle window resize events
    const width = gameSize.width;
    const height = gameSize.height;

    this.cameras.resize(width, height);
  }
}
